/**
 * メンテナンス関連
 */
export const maintenanceConfig = {
  startTime: import.meta.env.VUE_APP_MAINTENANCE_START_TIME,
  endTime: import.meta.env.VUE_APP_MAINTENANCE_END_TIME,
}

/**
 * セッション関連
 */
export const sessionConfig = {
  sessionTimeSpan: Number(import.meta.env.VUE_APP_SESSION_TIME_SPAN),
  responseCacheSpan: Number(import.meta.env.VUE_APP_RESPONSE_CACHE_SPAN) * 1000,
}

/**
 * 利用規約のバージョン
 */
export const termsVersion = "25112101"

/**
 * ソーシャルログイン種別
 */
export const socialLoginType = {
  none: 0,
  apple: 1,
  google: 2,
  microsoft: 3,
}